import { useVenueDataContext } from '@/VenueDataLoader'

export function useVenueGroup() {
  const { clientInfo: { lockedFields } = {} } = useVenueDataContext()
  return { lockedFields }
}
